import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const MoreThan90DaysChart = ({ data = [] }) => {
  const labels = data.map(d =>
    new Date(d.week_start).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short"
    })
  );

  const values = data.map(d => Number(d.outstanding_90_days_lakh));

  const chartData = {
    labels,
    datasets: [
      {
        label: "More than 90 Days",
        data: values,
        borderColor: "#d32f2f",
        backgroundColor: "rgba(211, 47, 47, 0.12)",
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
        fill: true,

        datalabels: {
          display: true,
          align: "top",
          anchor: "end",
          color: "#000",
          font: {
            weight: "bold",
            size: 10
          },
          formatter: (value) => value.toFixed(2)
        }
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      datalabels: {
        clamp: true,
        clip: false
      }
    },
    scales: {
      y: {
        
        title: {
          display: true,
          text: "M90",
        },
        ticks: {
          callback: (value) => `${Number(value).toFixed(2)} L`
        }
      },
      x: {
        title: {
          display: true,
          text: "DATE",
        },
        ticks: {
          minRotation: 90,
          maxRotation: 90,
          font: {
            size: 11,
          },
        },
      },
    },
  };

  return (
    <div style={{ height: 260 }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default MoreThan90DaysChart;
